
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

export function FloatingWhatsApp() {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsVisible(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Hide on the mobile linktree page (root "/" renders MobileLinkTree on mobile)
  if (pathname === "/" || !isVisible) return null;

  return (
    <a
      href="https://wa.me/5511998874081"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 right-6 z-50 group flex items-center gap-3"
      aria-label="Falar no WhatsApp"
    >
      {/* Tooltip */}
      <span className="bg-white text-gray-700 text-sm font-medium px-3 py-2 rounded-xl shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap border border-gray-100">
        Falar no WhatsApp
      </span>
      {/* Button */}
      <div className="relative">
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-20" />
        <div className="relative bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform flex items-center justify-center">
          <FaWhatsapp size={28} />
        </div>
      </div>
    </a>
  );
}
